import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail, LOGO_URL } from "@/lib/api";

export default function AdminLogin() {
  const { login, user, ready } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (ready && user) nav("/admin", { replace: true });
  }, [ready, user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-white border border-[#E2E8F0] rounded-sm px-4 py-3 text-sm focus:outline-none focus:border-[#2B4BB8] focus:ring-1 focus:ring-[#2B4BB8]";

  return (
    <div className="min-h-screen bg-[#0F172A] flex items-center justify-center px-5">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center mb-8">
          <img src={LOGO_URL} alt="logo" className="h-20 w-20 object-contain bg-white rounded-sm p-2" />
          <h1 className="mt-4 font-display text-2xl font-bold text-white">Staff Login</h1>
          <p className="text-sm text-[#94A3B8]">Kelowna Carpet Cleaning — Admin</p>
        </div>
        <form onSubmit={submit} data-testid="login-form" className="bg-white rounded-sm p-8 space-y-4">
          {error && (
            <div data-testid="login-error" className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-sm px-4 py-3">
              {error}
            </div>
          )}
          <div>
            <label className="text-xs font-bold uppercase tracking-widest text-[#94A3B8]">Email</label>
            <input data-testid="login-email" type="email" className={inputCls + " mt-1"} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@kelownacarpetcleaning.com" />
          </div>
          <div>
            <label className="text-xs font-bold uppercase tracking-widest text-[#94A3B8]">Password</label>
            <input data-testid="login-password" type="password" className={inputCls + " mt-1"} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
          </div>
          <button data-testid="login-submit-button" disabled={loading}
            className="w-full bg-[#1A2A5E] text-white font-bold py-3 rounded-sm hover:bg-[#2B4BB8] transition-colors disabled:opacity-60 flex items-center justify-center gap-2">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <><Lock className="w-4 h-4" /> Sign In</>}
          </button>
        </form>
        <a href="/" className="block text-center mt-6 text-sm text-[#94A3B8] hover:text-white">← Back to website</a>
      </div>
    </div>
  );
}
